<template>
    <div class="facturas w-full h-full bg-color-01" :class="[!isCollapsed ? 'wide-table-width':'tight-table-width']">
        <div class="w-full flex items-center px-5 h-13 bg-primary-700">
          <p class="text-xs">Gestión de proveedores</p>
        </div>
        <div class="w-full p-2">
          <Input placeholder="Buscar proveedores" v-model="searchUsers"/>
        </div>
        <kendo-grid :data-source="localDataSource"
              :pageable="true"
              :filterable="true"
              :reorderable="true"
              :resizable="true"
              :sortable="true"
              :column-menu="columnMenu"
              :change="onChange"
            >
            <kendo-grid-column class="max-w-10" :width="40" :selectable="true"/>
              <kendo-grid-column :width="250" :field="'Empresa'"
                      :title="'Empresa'">
              </kendo-grid-column>
              <kendo-grid-column :width="250" :field="'RazonSocial'"
                      :title="'Razón social'">
              </kendo-grid-column>
              <kendo-grid-column :width="120" :field="'CIFNIF'"
                      :title="'CIF/NIF'">
              </kendo-grid-column>
        </kendo-grid>
        <div class="buttons-bar absolute bottom-0 right-0 w-full flex items-center justify-end h-12 pr-4">
          <router-link :to="{name: 'supplierDetail'}">
            <Button type="primary"  size="small" icon="el-icon-plus"><span class="hidden sm:inline-block">Nuevo proveedor</span></Button>
          </router-link>
        </div>
        <div class="w-full absolute bottom-0 right-0 overflow-hidden transition-200 flex items-center px-4 global bg-primary-800" :class="[isSelected ? 'h-12':'h-0']" style="z-index:1">
          <div class="ml-auto">
            <Button @click="isSelected = !isSelected" type="danger" size="small" icon="el-icon-delete"><span class="hidden sm:inline-block">Eliminar proveedores</span></Button>
          </div>
        </div>
      </div>
</template>
<script>
import { Grid, GridColumn } from '@progress/kendo-grid-vue-wrapper'
import { Input, Button } from 'element-ui'
export default {
  name: 'list',
  components: {
    Input,
    Button,
    'kendo-grid': Grid,
    'kendo-grid-column': GridColumn
  },
  methods: {
    onChange () {
      this.isSelected = true
    },
    rowClik () {
      this.$router.push({ name: 'documentDetail' })
    }
  },
  data: function () {
    return {
      isCollapsed: false,
      darkMode: true,
      localDataSource: [
        {
          'Empresa': 'Dapibus Rutrum Limited',
          'RazonSocial': 'Dapibus Rutrum Limited',
          'CIFNIF': 'E9876543A'
        },
        {
          'Empresa': 'Bibendum Limited',
          'RazonSocial': 'Bibendum Limited',
          'CIFNIF': 'T71528339J'
        },
        {
          'Empresa': 'Sit Amet Associates',
          'RazonSocial': 'Sit Amet Associates',
          'CIFNIF': 'P98631487K'
        },
        {
          'Empresa': 'Dapibus Rutrum Limited',
          'RazonSocial': 'Dapibus Rutrum Limited',
          'CIFNIF': 'E9876543A'
        }
      ],
      // take: 10,
      // skip: 0,
      // sort: [],
      // filter: null,
      columnMenu: true,
      isSelected: false,
      searchUsers: ''
    }
  }
}

</script>
